/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
/**
 * Citizen rows don't have a settled shape yet: depending on the endpoint the
 * account fields sit at the root, or under a nested relation, and the name is
 * spelled either as one column or as a first/last pair.
 *
 * These resolvers walk the row and its usual nested relations so a listing
 * doesn't silently fall back to the email when a name is actually there.
 */
const NESTED_KEYS = ['citizen_account', 'citizenAccount', 'account', 'user', 'citizen']
const FULL_NAME_KEYS = ['name', 'full_name', 'fullname', 'display_name', 'username']
const FIRST_NAME_KEYS = ['firstname', 'first_name', 'given_name']
const LAST_NAME_KEYS = ['lastname', 'last_name', 'family_name']
const EMAIL_KEYS = ['email', 'mail']
const PHONE_KEYS = ['phone', 'phone_number', 'mobile', 'telephone']

function pick(source, keys) {
    for (const key of keys) {
        const value = source[key]
        if (typeof value === 'string' && value.trim()) return value.trim()
        if (typeof value === 'number') return String(value)
    }
    return ''
}

/** The row itself first, then the nested relations it may carry. */
function sources(row) {
    if (!row || typeof row !== 'object') return []
    const nested = NESTED_KEYS
        .map((key) => row[key])
        .filter((value) => value && typeof value === 'object')
    return [row, ...nested]
}

export function citizenName(row) {
    for (const source of sources(row)) {
        const full = pick(source, FULL_NAME_KEYS)
        if (full) return full

        const composed = [pick(source, FIRST_NAME_KEYS), pick(source, LAST_NAME_KEYS)]
            .filter(Boolean)
            .join(' ')
        if (composed) return composed
    }
    return ''
}

export function citizenEmail(row) {
    for (const source of sources(row)) {
        const email = pick(source, EMAIL_KEYS)
        if (email) return email
    }
    return ''
}

export function citizenPhone(row) {
    for (const source of sources(row)) {
        const phone = pick(source, PHONE_KEYS)
        if (phone) return phone
    }
    return ''
}
